import { HeadCell } from "../../../../../component/table/interfaces/TableInterface";

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'PosicaoFila', label: 'Posição na Fila' },
  { id: 'Veiculo', label: 'Veículo' },
  { id: 'Tipo', label: 'Tipo' },
  { id: 'Data', label: 'Data' },
  { id: 'HorarioEntrada', label: 'Horário Entrada' },
];